__turbopack_context__.v({
  "root": "index-module-scss-module__Bpj-wa__root",
});
